/**
 * ToggleSwitch - A modern on/off toggle switch component
 * Features a smooth light green/emerald color scheme
 */
import React from 'react';

export const ToggleSwitch = ({ 
  checked, 
  onChange, 
  disabled = false, 
  label = '',
  size = 'default', // 'small' | 'default' | 'large'
  testId = ''
}) => {
  const sizes = {
    small: { track: 'w-8 h-4', thumb: 'w-3 h-3', translate: 'translate-x-4' },
    default: { track: 'w-11 h-6', thumb: 'w-5 h-5', translate: 'translate-x-5' },
    large: { track: 'w-14 h-7', thumb: 'w-6 h-6', translate: 'translate-x-7' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <label 
      className={`inline-flex items-center gap-2 ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
      data-testid={testId}
    >
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange?.(!checked)}
        className={`
          relative inline-flex shrink-0
          ${s.track} 
          rounded-full 
          transition-colors duration-200 ease-in-out
          ${checked ? 'bg-emerald-500' : 'bg-gray-300'}
          ${!disabled && 'focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1'}
          ${disabled ? '' : 'hover:opacity-90'}
          border-0 p-0
        `}
        style={{ outline: 'none' }}
      >
        <span 
          className={`
            ${s.thumb}
            absolute top-0.5 left-0.5
            bg-white rounded-full shadow-sm
            transition-transform duration-200 ease-in-out
            pointer-events-none
            ${checked ? s.translate : 'translate-x-0'}
          `}
        />
      </button>
      {label && (
        <span className="text-sm text-gray-700 select-none">{label}</span>
      )}
    </label>
  );
};

export default ToggleSwitch;
